import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  action: {
    flexWrap: 'nowrap',
    height: 56,
    display: 'flex',
    borderRadius: 8,
    width: '100%',
    alignItems: 'center',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
    transition: 'background-color 100ms linear',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      '& .MuiChip-root': {
        backgroundColor: theme.palette.divider
      }
    }
  },
  text: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center'
  },
  deadline: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center'
  },
  iteration: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    width: 70,
    '& .MuiTypography-root': {
      textAlign: 'right'
    }
  },
  party: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center'
  },
  advice: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center'
  },
  fullWidth: {
    width: '95%'
  }
}))

export default useStyles
